import { useContext } from 'react';
import { WorkItemContext } from 'contexts/work_item_context';

const useWorkItem = () => {
    return useContext(WorkItemContext);
};

export default useWorkItem;
